import type { BackendRouteDefinition } from '../types';
import type { AcceptAragCaseRequestData } from '@cloudFunctions/types/arag/acceptAragCase';
import { withIdempotencyKeyHeader } from '../../../../../shared/backend/routes/idempotency';
import { buildDeterministicIdempotencyKey } from './buildDeterministicIdempotencyKey';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S3-WB2
// (PRA-790). Now served by `api-core-node` at
// `POST /api/firms/arag/cases:accept`. The legacy `acceptAragCase` callable
// continues to exist in `cloudFunctions/` so any deployed firms app version
// still holding the old route table can fall back to it; retirement of the
// callable export is deferred to S9-WB2.

// `acceptAragCase` is the first ARAG route to go through the durable
// mutation idempotency layer. We derive the Idempotency-Key client-side
// from a stable hash of the request payload so a double-click on the
// "Accept" button (or any transient network retry) coalesces against the
// same Firestore reservation rather than triggering a second accept POST
// to ARAG. See `buildDeterministicIdempotencyKey.ts` for the hash
// implementation and the hyphen-collision rationale.

// The firms-side `path` is the URL the client hits — Fastify's `::accept`
// route escape is server-only — so this is the raw `:accept` form. See the
// matching note in `services/api-core-node/src/routes/plugins/arag.ts`.
export const acceptAragCaseRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/arag/cases:accept',
  headers: (requestData: AcceptAragCaseRequestData) =>
    withIdempotencyKeyHeader({
      idempotencyKey: buildDeterministicIdempotencyKey({
        prefix: 'acceptAragCase',
        requestData,
      }),
    }),
} as const satisfies BackendRouteDefinition;
